import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-simple-cell__before"
}
const _hoisted_2 = { class: "ui-simple-cell__main" }
const _hoisted_3 = { class: "ui-simple-cell__content w-full" }
const _hoisted_4 = { class: "ui-simple-cell__slot w-full" }
const _hoisted_5 = {
  key: 1,
  class: "ui-simple-cell__after"
}

import UiTappable from "@/plugins/ui/components/tappable/UiTappable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiSimpleCell',
  props: {
  multiline: Boolean,
  active: Boolean,
  disabled: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiTappable, {
    class: _normalizeClass(["ui-simple-cell", {
      'ui-simple-cell--multiline': __props.multiline,
      'ui-simple-cell--active': __props.active,
      'ui-simple-cell--disabled': __props.disabled,
    }])
  }, {
    default: _withCtx(() => [
      (_ctx.$slots.before)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "before")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]),
      (_ctx.$slots.after)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "after")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})